import React, { useState } from 'react';
import { Modal, Form, Stack } from 'react-bootstrap';
import { Button } from 'lb-components';
import classes from './SecurityModal.module.scss';
import PropTypes from 'prop-types';
import { useTranslation } from 'lb-store';
import Config from 'lb-store/src/config/config';

export const SecurityModal = ({ onSuccess, onCancel, ...props }) => {
  const [counter, setCounter] = useState(0);
  const [securityCode, setSecurityCode] = useState('');
  const [error, setError] = useState('');
  const { t } = useTranslation();
  return (
    <Modal onHide={onCancel} contentClassName={classes.modal} {...props}>
      <Modal.Header
        className={classes.header}
        closeButton
        closeVariant={'white'}
      >
        <h1>{t('დამცავი კოდის შემოწმება')}</h1>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <Form
          className={classes.form}
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSuccess(
              securityCode,
              (e) => {
                setError(e);
                setSecurityCode('');
                setCounter(counter + 1)
              },
              onCancel
            );
          }}
        >
          <Form.Group className={classes.formGroup}>
            <Form.Label style={{ textAlign: 'start', display: 'flex' }}>
              {t('დამცავი კოდი')}
            </Form.Label>
            <div
              style={{
                display: 'flex',
                alignItems: 'stretch',
              }}
            >
              <div
                style={{
                  maxWidth: '50%',
                  minWidth: '100px',
                  width: '100px',
                  marginBottom: error !== '' ? '2.3rem' : 0,
                  marginRight: '1rem',
                  display: 'flex',
                  backgroundColor: '#424242',
                }}
              >
                <img
                  src={`${Config.Captcha}${counter}`}
                  style={{ width: '100%', cursor: 'pointer' }}
                  alt='captcha'
                  onClick={() => setCounter(counter + 1)}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  flex: 1,
                }}
              >
                <Form.Control
                  type={'number'}
                  style={{ flex: 1, marginRight: '0.6rem' }}
                  isInvalid={error !== ''}
                  value={securityCode}
                  onChange={(e) => {
                    setSecurityCode(e.target.value);
                    setError('');
                  }}
                />
                <Form.Control.Feedback
                  type='invalid'
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                  }}
                >
                  {t(error)}
                </Form.Control.Feedback>
              </div>
            </div>
          </Form.Group>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Button
              variant={'success'}
              type={'submit'}
              style={{ marginRight: '2rem' }}
            >
              {t('დადასტურება')}
            </Button>
            <Button variant={'secondary'} onClick={onCancel}>
              {t('გაუქმება')}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

SecurityModal.propTypes = {
  show: PropTypes.bool,
  centered: PropTypes.bool,
  message: PropTypes.string,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
};
SecurityModal.defaultProps = {
  show: true,
  centered: true,
};
